import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
function transform(transformKeyFunction) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function transformKeys(object) {
        if (object instanceof Date) {
            return object;
        }
        if (Array.isArray(object)) {
            return object.map(transformKeys);
        }
        if (!object || typeof object !== 'object') {
            return object;
        }
        const keys = Object.keys(object);
        if (keys.length === 0) {
            return object;
        }
        return keys.reduce((acc, key) => {
            acc[transformKeyFunction(key)] = transformKeys(object[key]);
            return acc;
        }, {});
    };
}
export function keysToCamel(obj) {
    return transform(camelCase)(obj);
}
export function keysToSnake(obj) {
    return transform(snakeCase)(obj);
}
